import { isDarkColor, Show } from '@elfsight/lib-utils';
import {
  ClearFiltersButton,
  DropdownChecklistControl,
  DropdownTagsControl,
  InlineFilters,
  useFilters
} from '@elfsight/widget-filters';
import { useSettings } from '@wu/widget-core';
import { useTranslation } from 'react-i18next';
import { SalaryDropdown } from '../components';
import type { FilterOptions } from '../types';
import { useJobFilters } from '../utils';

type InlineFiltersViewProps = {
  filterOptions: FilterOptions;
};

export function InlineFiltersView({ filterOptions }: InlineFiltersViewProps) {
  const { t } = useTranslation();
  const { filtersAndSearchColor } = useSettings();
  const { filtersAppliedCount, resetFilters } = useFilters();
  const { activeFilters } = useJobFilters();

  return (
    <InlineFilters>
      {activeFilters.map((filter) => {
        const { id, label, field } = filter;

        if (field === 'salary') {
          return (
            <SalaryDropdown
              key={id}
              label={label}
              filterName={field}
              options={filterOptions[field]}
            />
          );
        }

        const FilterControl =
          field === 'skills' ? DropdownTagsControl : DropdownChecklistControl;

        return (
          <FilterControl
            key={id}
            label={label}
            filterName={field}
            options={filterOptions[field]}
            triggerWithBackground={!isDarkColor(filtersAndSearchColor)}
          />
        );
      })}

      <Show when={filtersAppliedCount > 0}>
        <ClearFiltersButton onClick={resetFilters}>
          {t('Clear Filters')}
        </ClearFiltersButton>
      </Show>
    </InlineFilters>
  );
}
